/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminOverrideMatchScoreResponse
 */
export interface AdminOverrideMatchScoreResponse {
    /**
     * 
     * @type {string}
     * @memberof AdminOverrideMatchScoreResponse
     */
    matchId: string;
    /**
     * 
     * @type {string}
     * @memberof AdminOverrideMatchScoreResponse
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof AdminOverrideMatchScoreResponse
     */
    team1Score?: number;
    /**
     * 
     * @type {number}
     * @memberof AdminOverrideMatchScoreResponse
     */
    team2Score?: number;
    /**
     * 
     * @type {string}
     * @memberof AdminOverrideMatchScoreResponse
     */
    winnerId?: string;
}

/**
 * Check if a given object implements the AdminOverrideMatchScoreResponse interface.
 */
export function instanceOfAdminOverrideMatchScoreResponse(value: object): value is AdminOverrideMatchScoreResponse {
    if (!('matchId' in value) || value['matchId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    return true;
}

export function AdminOverrideMatchScoreResponseFromJSON(json: any): AdminOverrideMatchScoreResponse {
    return AdminOverrideMatchScoreResponseFromJSONTyped(json, false);
}

export function AdminOverrideMatchScoreResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminOverrideMatchScoreResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'matchId': json['matchId'],
        'status': json['status'],
        'team1Score': json['team1Score'] == null ? undefined : json['team1Score'],
        'team2Score': json['team2Score'] == null ? undefined : json['team2Score'],
        'winnerId': json['winnerId'] == null ? undefined : json['winnerId'],
    };
}

export function AdminOverrideMatchScoreResponseToJSON(json: any): AdminOverrideMatchScoreResponse {
    return AdminOverrideMatchScoreResponseToJSONTyped(json, false);
}

export function AdminOverrideMatchScoreResponseToJSONTyped(value?: AdminOverrideMatchScoreResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchId': value['matchId'],
        'status': value['status'],
        'team1Score': value['team1Score'],
        'team2Score': value['team2Score'],
        'winnerId': value['winnerId'],
    };
}

